import { gql } from '@apollo/client/core';

export const RESPOND_TO_REQUEST = gql`
  mutation respondToRequest(
    $requestId: UUID!
    $response: IdentifiedSitterResponse!
    $myAccount: MyAccountInput!
    $declinedReason: String
  ) {
    respondToRequest(requestId: $requestId, response: $response, myAccount: $myAccount, declinedReason: $declinedReason) {
      id
      start
      end
      sitter {
        id
        name
        photoUrl
      }
      parent {
        id
        name
      }
      location {
        details
        virtual
        geoPoint {
          x
          y
        }
      }
      familyMembers {
        name
        birthDate
      }
      details
      petInfo
    }
  }
`;

export const CANCEL_CONTRACT = gql`
  mutation cancelContract($id: UUID!) {
    cancelContract(id: $id)
  }
`;

export const CANCEL_REQUEST = gql`
  mutation cancelRequest($id: UUID!) {
    cancelRequest(id: $id)
  }
`;

export const CREATE_INTERVIEW_REQUEST = gql`
  mutation createInterviewRequest(
    $start: DateTime!
    $end: DateTime!
    $sitter: SitterAccountInput!
    $parent: MyAccountInput!
    $location: LocationInput!
    $familyMembers: [FamilyMemberInput!]!
    $details: String!
    $petInfo: [PetInformation!]!
    $rate: Int!
    $jobUuid: UUID
    $careType: CareType
  ) {
    createInterviewRequest(
      start: $start
      end: $end
      sitter: $sitter
      parent: $parent
      location: $location
      familyMembers: $familyMembers
      details: $details
      petInfo: $petInfo
      rate: $rate
      jobUuid: $jobUuid
      careType: $careType
    ) {
      id
    }
  }
`;

export const WRITE_CONTRACT_NOTE = gql`
  mutation writeAccountNotes($subjectID: UUID!, $notes: String!) {
    writeAccountNotes(subjectID: $subjectID, notes: $notes) {
      notes
    }
  }
`;
